/**
 * Comparação de versão do daemon, para a porta que recusa cliente velho.
 *
 * Por que uma função própria, e não `localeCompare` ou `<`: **comparação por
 * string diz que `0.10.0` é menor que `0.4.18`**, porque compara `1` com `4`.
 * A frota passa de 0.9 para 0.10 um dia, e nesse dia toda máquina atualizada
 * seria barrada por estar "velha demais" — o oposto do que a porta existe para
 * fazer, e do jeito mais difícil de desconfiar, porque só acontece uma vez.
 *
 * Fail closed: versão que não parseia é RECUSADA. Um daemon que não sabe dizer
 * quem é não é um daemon novo com formato diferente — é um cliente que a porta
 * não sabe julgar, e deixar passar seria a porta abrindo na dúvida.
 */

/** `0.5.0` → `[0, 5, 0]`. Devolve `null` para o que não é `n.n.n`. */
export function partesDaVersao(versao: string): [number, number, number] | null {
  const m = /^(\d+)\.(\d+)\.(\d+)$/.exec(versao.trim());
  if (!m) return null;
  const partes = [Number(m[1]), Number(m[2]), Number(m[3])] as const;
  if (partes.some((n) => !Number.isSafeInteger(n))) return null;
  return [partes[0], partes[1], partes[2]];
}

/**
 * `versao >= minima`, comparando número a número.
 *
 * `minima` malformada também devolve `false`: se a constante do nosso lado está
 * quebrada, barrar a frota inteira é ruidoso e se conserta na hora — deixar
 * passar é silencioso e se descobre num incidente.
 */
export function versaoAtende(versao: string, minima: string): boolean {
  const a = partesDaVersao(versao);
  const b = partesDaVersao(minima);
  if (a === null || b === null) return false;
  for (let i = 0; i < 3; i++) {
    const x = a[i] as number;
    const y = b[i] as number;
    if (x !== y) return x > y;
  }
  return true;
}
